/* SOULTENTIC: Fix modal sizing + disable hover-follow zoom (keep click) */
(() => {
  const BODY_CLASS = 'st-modal-open';

  function getOpenDialog() {
    // Most themes use role="dialog" for modals
    const dialogs = Array.from(document.querySelectorAll('[role="dialog"]'));
    // Find the one that's actually visible
    return dialogs.find(d => {
      const style = window.getComputedStyle(d);
      return style.display !== 'none' && style.visibility !== 'hidden' && d.offsetHeight > 0;
    }) || null;
  }

  function setBodyClass() {
    const dialog = getOpenDialog();
    document.body.classList.toggle(BODY_CLASS, !!dialog);
  }

  // Block hover-follow zoom motion inside modal without breaking click-to-zoom
  function stopHoverZoomMotion(e) {
    if (!document.body.classList.contains(BODY_CLASS)) return;

    const dialog = e.target.closest?.('[role="dialog"]');
    if (!dialog) return;

    // Only block motion events (mousemove/pointermove) that power “follow zoom”
    // Let clicks through so click-to-zoom still works.
    e.stopImmediatePropagation();
  }

  // Capture phase so we beat theme listeners
  window.addEventListener('mousemove', stopHoverZoomMotion, true);
  window.addEventListener('pointermove', stopHoverZoomMotion, true);

  // Watch for modal opening/closing
  const obs = new MutationObserver(() => setBodyClass());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', setBodyClass);
  window.addEventListener('load', setBodyClass);
})();
